import React from 'react';
import styled from 'styled-components';
import { FiYoutube } from 'react-icons/fi';
import { theme } from '../../theme';
import { subscribeUrl as defaultSubscribeUrl } from '../../config/social';

const Btn = styled.a`
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.6rem 1.4rem;
  background: #ff0000;
  border-radius: ${theme.radii.full};
  font-size: 0.85rem;
  font-weight: 600;
  color: #fff;
  text-decoration: none;
  transition: ${theme.transitions.default};

  &:hover { filter: brightness(1.1); transform: translateY(-2px); }
`;

// Bouton "S'abonner" réutilisable.
// - sans prop : chaîne VertinGo par défaut (config sociale)
// - avec `channelUrl` : n'importe quelle chaîne (Saga, Horizons…)
export default function SubscribeButton({ label = "S'abonner", channelUrl }) {
  const url = channelUrl
    ? `${channelUrl}${channelUrl.includes('?') ? '&' : '?'}sub_confirmation=1`
    : defaultSubscribeUrl();
  if (!url) return null;
  return (
    <Btn href={url} target="_blank" rel="noreferrer">
      <FiYoutube /> {label}
    </Btn>
  );
}
